export default "__VITE_ASSET__Bu$_JCS7__"